import {stringify} from 'query-string';
import {LINKS} from '@px/const/links';
import {SERVICES} from '@px/const/services';

export const fullImageUrlFun = (prefix = '/pubimg/') => {
  return (url) => {
    return url ? `${SERVICES.STATIC_URL}${prefix}${url}` : '';
  };
};

/**
 * 直接唤起链上入金弹窗
 */
export function getAutoChainDepositUrl(fixLink: (path: string) => string, otherParams?: Record<string, any>) {
  const path = fixLink(LINKS.ASSETS_DEPOSIT);
  const params = stringify({callChainDeposit: 1, ...(otherParams || {})});
  return `${path}?${params}`;
}

export function getFixedLinkFullUrl({lang, pathname}) {
  const path = appendLanguageToUrl({url: pathname, lang});
  if (typeof window === 'object') {
    return `${window.location.origin}${path}`;
  }
  return path;
}

function appendLanguageToUrl({url, lang}) {
  if (lang === 'en') {
    return url;
  }
  if (url === '/') {
    return '/' + lang;
  }
  return '/' + lang + url;
}
